import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	label: string;
	note: string;
	value: string;
	highlight?: boolean;
};

export const GoalRecapRow: FC<Props> = ({ label, note, value, highlight }) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			justifyContent="space-between"
			gap={1.2}
		>
			<Stack flex={1} minWidth={0}>
				<Typography
					variant={highlight ? "bodyStrong" : "body2"}
					color={theme.palette.grey[900]}
				>
					{label}
				</Typography>
				<Typography variant="note" color={theme.palette.grey[500]} mt={0.2}>
					{note}
				</Typography>
			</Stack>
			<Typography
				variant={highlight ? "subtitle3" : "bodyStrong"}
				color={highlight ? theme.palette.blue.main : theme.palette.grey[900]}
				tabular
				flexShrink={0}
			>
				{value}
			</Typography>
		</Stack>
	);
};
